module.exports = __webpack_public_path__ + "img/api.077cdfd2.png";